import { motion, useAnimation, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import FAQSection from "screens/Landing/components/FAQSection";
import { useUserStore } from "store/user";
import { ReferralRewards } from "./ReferralRewards";
import { YourReferralEarnings } from "./YourReferralEarnings";
import { useZoomScale } from "hooks/useZoomScale";

const ReferralsHeroSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const controls = useAnimation();
  const { user } = useUserStore();
  const [is4kDisplay, setIs4kDisplay] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const updateIs4kDisplay = () => {
      setIs4kDisplay(window.innerWidth >= 2160);
    };

    updateIs4kDisplay();
    window.addEventListener("resize", updateIs4kDisplay);

    return () => {
      window.removeEventListener("resize", updateIs4kDisplay);
    };
  }, []);

  const referralUrl = process.env.REACT_APP_REFERRAL_URL;

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const { scale } = useZoomScale();

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={containerVariants}
    >
      <div
        style={is4kDisplay ? { zoom: scale } : undefined}
        className="grid grid-cols-1 lg:grid-cols-[1fr_445px] max-lg:flex-col gap-4 lg:gap-8 relative z-20 max-lg:px-[12px] px-[0] max-w-[1296px]  mx-auto justify-center max-lg:max-w-[500px] lg:pb-10"
      >
        <div className="flex flex-col justify-between w-full relative">
          <ReferralRewards
            referralLink={`${referralUrl ? referralUrl : ""}/referral/${
              user.referralCode?.code || ""
            }`}
          />
          <div className="max-lg:hidden">
            <FAQSection isDashboard={true} />
          </div>
        </div>

        <YourReferralEarnings />
        <div className="lg:hidden">
          <FAQSection isDashboard={true} />
        </div>
      </div>
    </motion.section>
  );
};

export default ReferralsHeroSection;
